import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { getSignInPath } from '@/router';
import { TokenizedPaymentCard } from '@/models';

import { CountryCode } from '@/store/ui';
import { AccountPageLoadEvent } from '@/services/analytics/events';

@Component({
  name: 'CmgPaymentsAndGiftCardsPage',
})
export default class CmgPaymentsAndGiftCardsPage extends Vue {
  isLoading = true;
  errorMessage = '';

  async mounted() {
    try {
      const isLoggedIn = await this.$services.customer.waitForCustomerInitialization();
      if (isLoggedIn) {
        await this.$services.transaction.refreshPaymentCards();
      } else {
        this.$router.push(getSignInPath(this.$route.path));
      }
    } catch (err) {
      // TODO-arwss5: Handle error in UI
    } finally {
      this.isLoading = false;
    }

    this.$services.transaction.clearGiftCardBalanceCache();
  }

  get creditCards(): TokenizedPaymentCard[] {
    const providerId = this.$services.payment.getPaymentProvider(this.$appStore.state.ui.countryProfile.countryCode);
    return this.$appStore.state.customer.wallet.paymentCards.filter(card => card.isGiftCard == false && card.paymentProviderId == providerId);
  }

  get giftCards(): TokenizedPaymentCard[] {
    return this.$appStore.state.customer.wallet.paymentCards.filter(card => card.isGiftCard == true);
  }

  get addACardText(): string {
    return this.creditCards.length == 0 ? 'add a card' : 'add another card';
  }

  get hasReachedMaxCreditCards(): boolean {
    return this.$services.customer.isCustomerAtMaxCreditCards(this.$services.payment.getPaymentProvider(this.$appStore.state.ui.countryProfile.countryCode));
  }

  get hasReachedMaxGiftCards(): boolean {
    return this.$services.customer.isCustomerAtMaxGiftCards();
  }

  get areGiftCardsSupported(): boolean {
    return this.$appStore.state.ui.countryProfile.countryCode == 'US';
  }

  get isAboveStorePaymentOnline(): boolean {
    const flags = this.$appStore.state.featureFlags;
    if (flags.orderingStatus) {
      if (!flags.orderingStatus.aboveStorePaymentOnline) {
        return false;
      }
    
      if (this.siteCountryCode == CountryCode.US && !this.isPayeezyPaymentOnline) {
        return false;
      }
  
      if (this.siteCountryCode == CountryCode.CA && !this.isChasePaymentOnline) {
        return false;
      }
    } 

    return true;
  }

  get isChasePaymentOnline(): boolean {
    const flags = this.$appStore.state.featureFlags;
    if (flags.orderingStatus && !flags.orderingStatus.isChasePaymentOnline) {
      return false;
    }

    return true;
  }

  get isPayeezyPaymentOnline(): boolean {
    const flags = this.$appStore.state.featureFlags;
    if (flags.orderingStatus && !flags.orderingStatus.isPayeezyPaymentOnline) {
      return false;
    }

    return true;
  }

  get siteCountryCode(): string {
    return this.$appStore.state.ui.countryProfile.countryCode;
  }

  async onClickAddACreditCard(event: any) {
    this.$services.ui.pushEventTargetAsLastSelectedElement(event);
    this.$services.ui.setModalVisibility('addCreditOrDebitCardModal', true);
    this.$services.analytics.send(new AccountPageLoadEvent('add-credit-card'));
    this.$services.ui.firstFocus();
    
  }

  onClickAddAGiftCard(event: any) {
    this.$services.ui.pushEventTargetAsLastSelectedElement(event);
    this.$services.ui.setModalVisibility('addGiftCardModal', true);
    this.$services.analytics.send(new AccountPageLoadEvent('add-gift-card'));
    this.$services.ui.firstFocus();
  }
}
